import _styled from "styled-components";
import React from 'react';
import * as styles from "../styles/DrawerContainer.styles";
export var DrawerContainer = function DrawerContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.container
  }, children);
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "DrawerContainer___StyledDiv",
  componentId: "sc-vmfp9b-0"
})(["", ""], function (p) {
  return p.$_css;
});